/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderLoanPage from "../RenderLoanPage";
import { format } from "timeago.js";

function SettlementRequests() {
  const history = useHistory();
  const location = useLocation();
  const initialStatus = new URLSearchParams(location.search).get("status") || "pending";
  const [settlements, setSettlements] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState(initialStatus);
  const [search, setSearch] = useState("");

  const fetchSettlements = async (status) => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get(
        `/settlement${status ? `?status=${status}` : ""}`
      );
      setSettlements(res.data || []);
    } catch (err) {
      toast.error("Failed to load settlement requests.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSettlements(statusFilter);
  }, [statusFilter]);

  const filtered = settlements.filter((s) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      s.member_name?.toLowerCase().includes(q) ||
      s.staff_id?.toLowerCase().includes(q) ||
      s.loan_id?.toLowerCase().includes(q)
    );
  });

  const statusBadge = (status) => {
    const map = {
      pending: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
      processed: { bg: "#e8f5e9", color: "#2e7d32", border: "#81c784" },
    };
    const s = map[status] || map.pending;
    return (
      <span
        style={{
          background: s.bg,
          color: s.color,
          border: `1px solid ${s.border}`,
          padding: "3px 10px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 600,
          textTransform: "capitalize",
        }}
      >
        {status}
      </span>
    );
  };

  const pageTitle = statusFilter === "processed" ? "Sent Settlements" : "Settlement Requests";

  return (
    <RenderLoanPage title={pageTitle}>
      <ToastContainer />
      <div style={{ padding: "0 4px" }}>
        {/* Filters */}
        <div
          style={{
            display: "flex",
            gap: 12,
            marginBottom: 20,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            placeholder="Search by name, staff ID or loan ID..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              padding: "9px 14px",
              border: "1px solid #ddd",
              borderRadius: 8,
              fontSize: 14,
              flex: 1,
              minWidth: 220,
              outline: "none",
            }}
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              padding: "9px 14px",
              border: "1px solid #ddd",
              borderRadius: 8,
              fontSize: 14,
              outline: "none",
              cursor: "pointer",
            }}
          >
            <option value="">All</option>
            <option value="pending">Pending</option>
            <option value="processed">Processed</option>
          </select>
        </div>

        {/* Table */}
        <div
          style={{
            background: "#fff",
            borderRadius: 10,
            boxShadow: "0 1px 8px rgba(0,0,0,0.07)",
            overflow: "hidden",
          }}
        >
          {isLoading ? (
            <div style={{ textAlign: "center", padding: 50, color: "#888" }}>
              Loading...
            </div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: 50, color: "#888" }}>
              No settlement requests found.
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
                <thead>
                  <tr style={{ background: "#f5f5f5" }}>
                    {["#", "Member Name", "Staff ID", "Loan ID", "Email", "Phone", "Status", "Submitted", "Action"].map(
                      (h) => (
                        <th
                          key={h}
                          style={{
                            padding: "12px 14px",
                            textAlign: "left",
                            fontWeight: 700,
                            color: "#333",
                            borderBottom: "2px solid #e0e0e0",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {h}
                        </th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((s, idx) => (
                    <tr
                      key={s._id}
                      style={{
                        background: idx % 2 === 0 ? "#fff" : "#fafafa",
                        borderBottom: "1px solid #f0f0f0",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        history.push(`/loans/settlement-detailed?id=${s._id}`)
                      }
                    >
                      <td style={td}>{idx + 1}</td>
                      <td style={{ ...td, fontWeight: 600 }}>{s.member_name}</td>
                      <td style={td}>{s.staff_id}</td>
                      <td style={td}>{s.loan_id || "—"}</td>
                      <td style={td}>{s.email}</td>
                      <td style={td}>{s.phone}</td>
                      <td style={td}>{statusBadge(s.status)}</td>
                      <td style={{ ...td, color: "#888", fontSize: 12 }}>
                        {s.created_at ? format(s.created_at) : "—"}
                      </td>
                      <td style={td}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            history.push(`/loans/settlement-detailed?id=${s._id}`);
                          }}
                          style={{
                            background: s.status === "processed" ? "#1565c0" : "#2d6a4f",
                            color: "#fff",
                            border: "none",
                            borderRadius: 6,
                            padding: "6px 14px",
                            fontSize: 13,
                            cursor: "pointer",
                            fontWeight: 600,
                          }}
                        >
                          {s.status === "processed" ? "View" : "Process"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </RenderLoanPage>
  );
}

const td = {
  padding: "11px 14px",
  color: "#444",
  verticalAlign: "middle",
};

export default SettlementRequests;
